import React from "react";
import {useDispatch} from "react-redux";
import showToast from "../../Global/Hooks/toast";
import {setLoader} from "../../Store/Slice/techsbookSlice";
import {useLazyToggleReferQuery} from "../../Store/Builder/dashboard.api";
import useGetTechnicians from "../../Global/Api/Dashboard/getTechinicians.api";
import "./index.scss";

export default function TechnicianCard({
  technician,
  setModal,
  setCurrentItem,
    page
}) {
  const dispatch = useDispatch();
  const [getAllTechniciansLocations] = useLazyToggleReferQuery();
  const getTechnicians = useGetTechnicians(page);

  const toggleRefer = async (e, id) => {
    e.stopPropagation();
    dispatch(setLoader(true));
    getAllTechniciansLocations({id})
      .unwrap()
      .then(res => {
        dispatch(setLoader(false));
        getTechnicians.get();
        showToast(res?.data?.message ?? "Success", "success");
      })
      .catch((err) => {
        dispatch(setLoader(false));
        console.log(err)
        showToast(err?.data?.message ?? "Error", "error");
      });
  };

  return (
    <div key={technician?.id} className="technicianCard">
      <div className="technicianCard__top">
        <div className="technicianCard__top-left">
          <div className="technicianCard__avatar">
            <img
              src={
                technician?.profile_image ?? "./assets/icons/user-example.svg"
              }
              alt="avatar"
            />
          </div>
          <div className="technicianCard__info">
            <p className="technicianCard__name">{`${technician?.firstname} ${technician?.lastname}`}</p>
            <p className="technicianCard__id">{`Tech ID: ${technician?.id}`}</p>
          </div>
          <div className="technicianCard__rating">
            <span>
              <img src="/assets/icons/star-rating.svg" alt="star" />
            </span>
            {technician?.average_rating || 0}
          </div>
        </div>
        <div className="technicianCard__top-right">
          <div
              className="technicianCard__calendar"
              onClick={() => {
                setModal(true);
                setCurrentItem(technician);
              }}>
            <img src="/assets/icons/calendar.svg" alt="calendar" />
          </div>
          <div className="technicianCard__refer" onClick={(e) => toggleRefer(e, technician?.id)}>
            {
              technician?.favorite
                ? (
                    <img src="/assets/icons/icon-reffered.svg" alt=""/>
                  )
                : (
                    <img src="/assets/icons/icon-unreffered.svg" alt=""/>
                  )
            }
            <div className="technicianCard__refer-content">
              <p>When you mark a technician as a favorite, they’ll appear only if they are within the selected radius in the scheduling section.</p>
            </div>
          </div>
        </div>
      </div>
      <div className="technicianCard__bottom">
        <div className="technicianCard__bottom-left">
          {technician?.level === null ? (
                <div
                  style={{ alignItems: "flex-start", display: 'flex', flexDirection: 'column' }}
                  className="technicianCard__badge"
                >
                  <div style={{ alignItems: "center", display: 'flex' }}>
                    <div className="technicianCard__badge-icon">
                      <img src="/assets/icons/badge-none.svg" alt="" />
                    </div>
                    <div className="technicianCard__badge-info">
                      <p className="technicianCard__badge-name">No level</p>
                    </div>
                    <span className="technicianCard__badge-more">
                      <img src="/assets/icons/info.svg" alt="info" />
                    </span>
                    <div className="technicianCard__badge-content">
                      <p>Technician level</p>
                    </div>
                  </div>
                  <p style={{ paddingLeft: '8px' }} className="technicianCard__badge-text">{`${
                    technician?.installations || 0
                  } Installations`}</p>
              </div>

          ) : (
            <div className="technicianCard__badge">
              <div className="technicianCard__badge-icon">
                <img
                  src={technician?.level?.image ?? "./assets/icons/badge-1.svg"}
                  alt=""
                />
              </div>
              <div className="technicianCard__badge-info">
                <p className="technicianCard__badge-name">
                  {technician?.level?.name || "none"}
                </p>
                <p className="technicianCard__badge-text">{`${
                  technician?.installations || 0
                } Installations`}</p>
              </div>
              <span className="technicianCard__badge-more">
                <img src="/assets/icons/info.svg" alt="info" />
              </span>
              <div className="technicianCard__badge-content">
                <p>Technician level</p>
              </div>
            </div>
          )}
        </div>
        <div className="technicianCard__bottom-right">
          {technician?.certificates.map((certificate) => (
            <div key={certificate?.id} className="technicianCard__certificate">
              {certificate?.name}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
